"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserHeaderNav = exports.UserUnloggedHeaderNav = exports.UserLoggedHeaderNav = exports.LogoutLink = exports.AccountLink = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const I18n_1 = require("../../../i18n/I18n");
const Identity_1 = require("../../../identity/Identity");
const NavItem_1 = require("../../../nav/NavItem");
const Router_1 = require("../../../router/Router");
const UI_1 = require("../../UI");
exports.AccountLink = react_1.forwardRef(function AccountLink(
// eslint-disable-next-line react/prop-types
_a, ref) {
    var 
    // eslint-disable-next-line react/prop-types
    { NavItemComponent, onClick } = _a, props = tslib_1.__rest(_a, 
    // eslint-disable-next-line react/prop-types
    ["NavItemComponent", "onClick"]);
    const { useLink } = UI_1.useUIContext();
    const { t } = I18n_1.useTranslation("identity");
    const router = Router_1.useRouterContext().useRouter();
    const handleClick = (event) => {
        if (onClick) {
            onClick(event);
        }
        router.push("/account");
    };
    const linkComponentProps = Object.assign({ children: t("My account") }, props);
    return useLink(Object.assign({ onClick: handleClick, Component: NavItemComponent, ref }, linkComponentProps));
});
function LogoutLink(_a) {
    var { NavItemComponent = NavItem_1.NavItem, onClick } = _a, props = tslib_1.__rest(_a, ["NavItemComponent", "onClick"]);
    const { logout } = Identity_1.useIdentityContext();
    const { t } = I18n_1.useTranslation("identity");
    const router = Router_1.useRouterContext().useRouter();
    const { useLoader, useErrorNotification } = UI_1.useUIContext();
    const { loader, setLoading } = useLoader({ loading: false });
    const { errorNotification, setErrorNotification } = useErrorNotification({
        title: t("Log out"),
    });
    const { useLink } = UI_1.useUIContext();
    const handleLogout = (event) => {
        setLoading(true);
        setErrorNotification(undefined);
        if (onClick) {
            onClick(event);
        }
        logout()
            .then(() => router.push("/"))
            .catch(setErrorNotification)
            .finally(() => setLoading(false));
    };
    const linkComponentProps = Object.assign({ children: t("Log out"), onClick: handleLogout }, props);
    const link = useLink(Object.assign({ Component: NavItemComponent }, linkComponentProps));
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [loader, errorNotification, link] }, void 0));
}
exports.LogoutLink = LogoutLink;
function UserLoggedHeaderNav({ NavItemComponent = NavItem_1.NavItem, }) {
    const { user, displayName } = Identity_1.useIdentityContext();
    if (!user) {
        return null;
    }
    const withNavItemComponentProps = {
        NavItemComponent: NavItemComponent,
    };
    return (jsx_runtime_1.jsxs("ul", Object.assign({ title: displayName() || "" }, { children: [jsx_runtime_1.jsx(exports.AccountLink, Object.assign({}, withNavItemComponentProps), void 0),
            jsx_runtime_1.jsx(LogoutLink, Object.assign({}, withNavItemComponentProps), void 0)] }), void 0));
}
exports.UserLoggedHeaderNav = UserLoggedHeaderNav;
function UserUnloggedHeaderNav({ NavItemComponent = NavItem_1.NavItem, }) {
    const { t } = I18n_1.useTranslation();
    const { user, AuthComponent } = Identity_1.useIdentityContext();
    const { useModal } = UI_1.useUIContext();
    const { useLink } = UI_1.useUIContext();
    const { modal, openModal } = useModal({
        title: t("Sign In / Sign Up"),
        body: jsx_runtime_1.jsx(AuthComponent, {}, void 0),
    });
    react_1.useEffect(() => {
        if (user) {
            // closeModal();
        }
    }, [user]);
    if (user) {
        return null;
    }
    const linkComponentProps = {
        children: t("Sign In / Sign Up"),
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onClick: (event) => openModal(),
    };
    const link = useLink(Object.assign({ Component: NavItemComponent }, linkComponentProps));
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [modal, link] }, void 0));
}
exports.UserUnloggedHeaderNav = UserUnloggedHeaderNav;
function UserHeaderNav() {
    const { identityProvider } = Identity_1.useIdentityContext();
    if (!identityProvider) {
        return null;
    }
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx(UserLoggedHeaderNav, {}, void 0),
            jsx_runtime_1.jsx(UserUnloggedHeaderNav, {}, void 0)] }, void 0));
}
exports.UserHeaderNav = UserHeaderNav;
//# sourceMappingURL=UserHeaderNav.js.map